// angular
// 	.module('HeroPRO')
// 	.config(exceptionInterceptor);
/* @ngInject */
export default function exceptionInterceptor($provide) {
    $provide.decorator('$exceptionHandler', ['hpLoggerService', function (hpLoggerService) {
        return function (exception, cause) {
            hpLoggerService.frameworkError(exception, cause);
        };
    }]);
}



// WEBPACK FOOTER //
// ./src/app/config/app.logging.config.js